import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { useMatchConfirm } from "@/hooks/useMatchConfirm"
import { useMatchSearch } from "@/hooks/useMatchSearch"
import { useModals } from "@/modals"
import { useAppDispatch, useAppSelector } from "@/store"
import { useGetMyFriendLobbyQuery } from "@/store/apis/friendLobbyAPI"
import {
  COMMON_BID_VARIANT_ID,
  useGetMyMatchSessionQuery
} from "@/store/apis/matchAPI"
import { useGetPlayerProfileQuery } from "@/store/apis/playerAPI"
import {
  FindMatchSelectors,
  setFindMatchIsSearching,
  setFindMatchMode
} from "@/store/slices/findMatch"
import { MatchSelectors } from "@/store/slices/match"

export const useFindMatchListener = () => {
  const [searchParams] = useSearchParams()
  const dispatch = useAppDispatch()
  const { openModal, closeAllModals } = useModals()
  const { toDeck } = useMatchSearch()
  const { confirmStatus } = useMatchConfirm()

  const matchSession = useAppSelector(MatchSelectors.selectMatchSession())
  const findMatchMode = useAppSelector(FindMatchSelectors.selectFindMatchMode())

  const { data: playerProfile } = useGetPlayerProfileQuery()
  const { data: matchSessionQuery } = useGetMyMatchSessionQuery(
    {
      playerId: playerProfile?._id ?? ""
    },
    {
      skip: !playerProfile?._id
    }
  )
  const { data: friendLobby } = useGetMyFriendLobbyQuery(undefined, {
    skip: !playerProfile?._id
  })

  useEffect(() => {
    if (findMatchMode === "label") return

    if (playerProfile?.inQueue) {
      dispatch(setFindMatchMode("modal"))

      if (playerProfile.matchBidVariant === COMMON_BID_VARIANT_ID) {
        openModal("findMatch")
      } else {
        openModal("findTonMatch")
      }
    }

    if (matchSession?.status === "PENDING") {
      dispatch(setFindMatchMode("modal"))
      openModal("findTonMatch")
    }
  }, [
    playerProfile?.inQueue,
    playerProfile?.matchBidVariant,
    matchSession?.status
  ])

  useEffect(() => {
    if (playerProfile?.inQueue) {
      dispatch(setFindMatchIsSearching(true))
      return
    }

    if (matchSession?.status === "PENDING") {
      dispatch(setFindMatchIsSearching(true))
      return
    }

    dispatch(setFindMatchIsSearching(false))
  }, [playerProfile?.inQueue, matchSession?.status])

  useEffect(() => {
    switch (matchSessionQuery?.status) {
      case "PENDING":
        break
      case "ACTIVE":
        toDeck(undefined, 500)
        break

      default:
        break
    }
  }, [matchSessionQuery?.status])

  useEffect(() => {
    if (confirmStatus && ["EXPIRED", "REJECTED"].includes(confirmStatus)) {
      closeAllModals()
    }
  }, [confirmStatus])

  useEffect(() => {
    if (!friendLobby) return

    openModal("playWithFriend")
  }, [friendLobby])

  useEffect(() => {
    if (
      !playerProfile ||
      playerProfile?.inQueue ||
      playerProfile?.currentSessionId
    ) {
      return
    }

    const friendInviteCodeTg =
      window.location.search.split("friendInviteCode_")[1]
    const friendInviteCodeParam = searchParams.get("friendInviteCode")

    if (friendInviteCodeTg || friendInviteCodeParam) {
      openModal("playWithFriend")
      return
    }
  }, [playerProfile])
}
